import { render, staticRenderFns } from "./ArchivedDebt.vue?vue&type=template&id=0a30e91e"
import script from "./ArchivedDebt.vue?vue&type=script&lang=js"
export * from "./ArchivedDebt.vue?vue&type=script&lang=js"
import style0 from "./ArchivedDebt.vue?vue&type=style&index=0&id=0a30e91e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports